<template>
  <div class="welcome">
    <el-form ref="addForm" :model="addForm" label-width="120px">
      <el-form-item label="账号" class="workNumber">
        <el-input size="small" v-model="addForm.workNumber" placeholder="请输入账号" clearable></el-input>
      </el-form-item>
      <el-form-item label="手机号码" class="phone">
        <el-input size="small" v-model="addForm.phone" placeholder="请输入手机号码" clearable></el-input>
      </el-form-item>
      <el-form-item class="btn">
        <el-button type="primary" size="small" class="search" @click="bindNewEmployee">入职绑定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'Sign',
  data() {
    return {
      imgList: [],
      input: '',
      addForm: {
        workNumber: '',
        phone: ''
      }
    }
  },
  mounted() {
    this.$root.$children[0].sign('http://17l.link/dist/?id=1&targetName=Customer&wechatLogin=true&state=123')
    if (this.$common.session.get('signForm')) {
      this.addForm = this.$common.session.get('signForm')
    }
    if (this.addForm.workNumber && this.addForm.phone && this.$route.params.code) {
      this.bindNewEmployee()
    }
  },
  methods: {
    // 入职绑定
    bindNewEmployee() {
      if (!this.addForm.workNumber) {
        return this.$toast('请填写账户')
      }
      if (!this.addForm.phone) {
        return this.$toast('请填写账户手机号码')
      }
      this.$common.session.set('signForm', this.addForm)
      if (!this.$route.params.code) {
        window.location.href = './?wechatLogin=true&targetName=Sign&id=' + this.$route.params.id + '&state=111'
        return
      }
      const param = {
        workNumber: this.addForm.workNumber,
        phone: this.addForm.phone,
        code: this.$route.params.code
      }
      this.$get('/user/bindNewEmployee', param).then(
        result => {
          if (result.status === 200) {
            this.$dialog
              .alert({
                message: result.msg
              })
              .then(() => {
                const targetName = this.$common.session.get('SignTargetName')
                window.location.href =
                  './?wechatLogin=true&targetName=' + targetName + '&id=' + this.$route.params.id + '&state=111'
                // eslint-disable-next-line no-undef
                // WeixinJSBridge.call('closeWindow')
              })
          } else {
            this.$dialog
              .alert({
                message: result.msg
              })
              .then(() => {
                window.location.href = './?wechatLogin=true&targetName=Sign&id=' + this.$route.params.id + '&state=111'
              })
          }
        },
        error => {
          this.$dialog.alert({
            message: error.name + ':' + error.message
          })
        }
      )
    }
  },
  destroyed() {}
}
</script>

<style lang="less" scoped>
.welcome {
  padding: 5vw;
  box-sizing: border-box;
  .img-box {
    display: flex;
    flex-wrap: wrap;
    .img {
      img {
        max-width: 200px;
      }
    }
  }
  .scan-icon {
    padding-top: calc(50vh - 20vw);
    text-align: center;
    color: #10a60e;
    /deep/.van-icon-scan {
      font-size: 30vw;
    }
  }
}
</style>
